import React, {useEffect, useRef, useState} from "react";
import "./NewCampaignCoverModal.css";
import NewCampaignCoverCropper from "@/react_app/NewCampaignCoverCropper/NewCampaignCoverCropper";
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import { FileUpload } from 'primereact/fileupload';
import { Image } from "primereact/image";

const AddNew = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="59" height="59" viewBox="0 0 59 59" fill="none">
      <path d="M29.5 0C21.7053 0.0940405 14.2564 3.23226 8.74433 8.74433C3.23226 14.2564 0.0940405 21.7053 0 29.5C0.0940405
       37.2947 3.23226 44.7436 8.74433 50.2557C14.2564 55.7677 21.7053 58.906 29.5 59C37.2947 58.906 44.7436 55.7677 50.2557
       50.2557C55.7677 44.7436 58.906 37.2947 59 29.5C58.906 21.7053 55.7677 14.2564 50.2557 8.74433C44.7436 3.23226 37.2947
       0.0940405 29.5 0ZM46.3571 31.6071H31.6071V46.3571H27.3929V31.6071H12.6429V27.3929H27.3929V12.6429H31.6071V27.3929H46.3571V31.6071Z"
            fill="#9F9EA0" />
    </svg>
  )
}

export default function(props){
  const [newCover, setNewCover] = useState('');
  const [openCropper, setOpenCropper] = useState(false);
  const [availablePhotos, setAvailablePhotos] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(-1);

  const fileUploadRef = useRef();

  useEffect(() => {
    if (props.coverImage) {
      setNewCover(props.coverImage);
    }
    setAvailablePhotos([]);
  }, [props.coverImage, props.close]);

  const handleFileUpload = ({files}) => {
    const [uploadPhotoInput] = files;
    if (uploadPhotoInput) {
      const file = uploadPhotoInput;
      const reader = new FileReader();
      reader.onload = () => {
        setAvailablePhotos([...availablePhotos, reader.result])
      };
      reader.readAsDataURL(file);
    }
    fileUploadRef.current.clear();
  };

  return(
    <Dialog className={'campaign-cover-modal'} visible={props.visible} onHide={props.close}>
      <div className={'top-layer'}>
        <i className="pi pi-times" style={{ fontSize: '25px', color: "#fff", cursor: "pointer" }} onClick={props.close}/>
      </div>
      <div className={'content'}>
        <p className={'title'}>Cover Image</p>
        <p className={'subTitle'}>Upload a nice image for your content to make it more wanted!</p>
        <div className={'contentMain'}>
          <div className={'contentLeft'}>
            <Image src={newCover} alt={'cover image'} className={'coverImage'}/>
            <Button disabled={selectedPhoto === -1} className={'cropButton'} onClick={() => setOpenCropper(true)}>Crop Image</Button>
          </div>
          <div className={'contentRight'}>
            <p className={'label'}>Select a new image</p>
            <div className={'photosGrid'}>
              {availablePhotos.map((photo, index) => {
                return (
                  <div className={'addedPhotoWrapper'} key={index} onClick={() => { setSelectedPhoto(index); setNewCover(photo) }}>
                    <Image className={selectedPhoto === index ? 'addedPhotoSelected' : ''} src={photo} alt={'cover option'}/>
                  </div>
                )
              })}
              {availablePhotos.length < 6 &&
                <FileUpload ref={fileUploadRef} disabled={availablePhotos.length >= 8} mode="basic" name="photo"
                            accept="image/*" auto={true} customUpload={true} uploadHandler={handleFileUpload}>
                </FileUpload>
              }
            </div>
          </div>
        </div>
        <div className={'buttonLayer'}>
          <Button className={'saveButton'} onClick={() => {props.setCoverImage(newCover); props.close()}}>Save Changes</Button>
        </div>
      </div>
      <NewCampaignCoverCropper visible={openCropper} close={() => setOpenCropper(false)} image={newCover} setNewCover={setNewCover}/>
    </Dialog>
  )
}
